import {
  call,
  put,
  takeLatest
} from "redux-saga/effects";
import {
  schema
} from "normalizr";
import {
  uploadFile,
  authorizedRequest,
  downloadXLSFile,
  downloadLocalFile
} from "utils/api";
import {
  ToastSuccess,
  ToastError
} from "components/Global/Toasts/Toasty";

export const LIBOR_FILE_UPLOAD_REQUEST = "LIBOR_FILE_UPLOAD_REQUEST";
export const LIBOR_FILE_UPLOAD_FAILURE = "LIBOR_FILE_UPLOAD_FAILURE";
export const LIBOR_FILE_UPLOAD_SUCCESS = "LIBOR_FILE_UPLOAD_SUCCESS";

export const LIBOR_GET_REQUEST = "LIBOR_GET_REQUEST";
export const LIBOR_GET_FAILURE = "LIBOR_GET_FAILURE";
export const LIBOR_GET_SUCCESS = "LIBOR_GET_SUCCESS";

export const LIBOR_GET_EXCEL_REQUEST = "LIBOR_GET_EXCEL_REQUEST";
export const LIBOR_GET_EXCEL_FAILURE = "LIBOR_GET_EXCEL_FAILURE";
export const LIBOR_GET_EXCEL_SUCCESS = "LIBOR_GET_EXCEL_SUCCESS";

export const LIBOR_KEY = "libor";
export const LIBOR_ENTITY = new schema.Entity(LIBOR_KEY, {});
export const LIBOR_SCHEMA = [LIBOR_ENTITY];

const initialState = {};

export default function liborReducer(state = initialState, action) {
  const {
    type,
    payload
  } = action;
  switch (type) {
    case LIBOR_FILE_UPLOAD_SUCCESS:
      return {
        ...state,
        ...payload
      };

    case LIBOR_GET_SUCCESS:
      return {
        libor: payload.libor
      };

    case LIBOR_GET_EXCEL_SUCCESS:
      return {
        ...payload
      };

    case LIBOR_GET_FAILURE:
      return {
        succes: "error"
      };

    default:
      return state;
  }
}

// UPLOAD Libor
export function addLibor(model, modelId, file, url) {
  return {
    type: LIBOR_FILE_UPLOAD_REQUEST,
    model,
    modelId,
    file,
    url
  };
}
export function addLiborSuccess(payload) {
  return {
    type: LIBOR_FILE_UPLOAD_SUCCESS,
    payload
  };
}
export function addLiborFailure(error) {
  return {
    type: LIBOR_FILE_UPLOAD_FAILURE,
    error
  };
}

// GET Libor
export function getLibor(payload) {
  return {
    type: LIBOR_GET_REQUEST,
    payload
  };
}
export function getLiborSuccess(payload) {
  return {
    type: LIBOR_GET_SUCCESS,
    payload
  };
}
export function getLiborFailure(error) {
  return {
    type: LIBOR_GET_FAILURE,
    error
  };
}

// GET XLS WORKSHEET FILE for Libor
export function getLiborExcel(payload) {
  return {
    type: LIBOR_GET_EXCEL_REQUEST,
    payload
  };
}
export function getLiborExcelSuccess(payload) {
  return {
    type: LIBOR_GET_EXCEL_SUCCESS,
    payload
  };
}
export function getLiborExcelFailure(error) {
  return {
    type: LIBOR_GET_EXCEL_FAILURE,
    error
  };
}

// Saga UPLOAD Libor
function* addLiborSaga(payload) {
  try {
    const response = yield call(uploadFile, payload);
    yield put(addLiborSuccess(response));
    ToastSuccess("File Uploaded Successfully");
  } catch (error) {
    yield put(addLiborFailure(error));
    if (error.response.status !== 401) {
      ToastError(`Upload Failed: ${error.message}`);
    }
  }
}

// Saga GET Libor
function* getLiborSaga() {
  try {
    const response = yield call(authorizedRequest, "/libor/upload", "GET");
    yield put(getLiborSuccess(response));
  } catch (error) {
    yield put(getLiborFailure(error));
    if (error.response.status !== 401) {
      ToastError(error.message);
    }
  }
}

// Saga GET Excel Libor`
function* getLiborExcelSaga() {
  try {
    const response = yield call(
      downloadLocalFile,
      "/LIBOR%20Upload%20Model.xlsx",
      "GET",
      undefined,
      "LIBOR Upload Model"
    );
    yield put(getLiborSuccess(response));
  } catch (error) {
    yield put(getLiborFailure(error));
    if (error.response.status !== 401) {
      ToastError(error.message);
    }
  }
}

export function* liborSaga() {
  yield takeLatest(LIBOR_FILE_UPLOAD_REQUEST, addLiborSaga);
  yield takeLatest(LIBOR_GET_REQUEST, getLiborSaga);
  yield takeLatest(LIBOR_GET_EXCEL_REQUEST, getLiborExcelSaga);
}
